class UiState {
	isLoading = $state(false);
	errorMessage = $state<string | null>(null);
	isExporting = $state(false);
	createDialogData = $state<unknown>(null);
	scenePreview = $state<unknown>(null);
	ledLogicPreview = $state<unknown>(null);
	validationResults = $state<unknown[]>([]);
	currentPhase = $state('project');
}

export const uiState = new UiState();

export function setLoading(loading: boolean) {
	uiState.isLoading = loading;
}

export function clearError() {
	uiState.errorMessage = null;
}

export function setError(message: string) {
	uiState.errorMessage = message;
}
